import './index.css';

// ----------------------------------------------------------------------

export default function ChildTitle(props) {
  return (
    <div className="childtitle">
      {props.title}
    </div>
  );
}
